import { PLP_ROOTS } from '@core/Constants/Plp';
import type { PlpRoot } from '@core/Entities/Search/PlpRoot.entity';

function getRootFromPath(path: string): PlpRoot {
  const calcdRoot = path.split('/')[2];

  if (PLP_ROOTS.includes(calcdRoot as PlpRoot)) return calcdRoot as PlpRoot;

  return 'used';
}

export { getRootFromPath };
